import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import glamorous, { A } from 'glamorous'

import { COLORS } from 'config'

const linkStyle = {
  fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSize: 18,
  lineHeight: 1.3,
  color: COLORS.blue
}

const Link = glamorous(RouterLink)(linkStyle)

export default class CommonLink extends React.PureComponent {
  static propTypes = {
    external: PropTypes.bool,
    css: PropTypes.object
  }

  render() {
    const { external, css, ...rest } = this.props

    if (this.props.external) {
      return <A {...rest} css={{ ...linkStyle, ...css }} />
    }

    return <Link {...rest} css={css} />
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Link.js